// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-417d9691] {\n  color: #e9a021;\n  cursor: default;\n}\n.home-container .wang-editor-style[data-v-417d9691] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
